import { SET_MA_NAVIGATION } from './ma-navigation-actions';
export const maNavigationReducer = (state = {
    navigatableMembersRoles: [],
    isNavigationAllowed: false,
    profileLinkTemplate: '',
}, action) => {
    switch (action.type) {
        case SET_MA_NAVIGATION:
            return action.payload;
        default:
            return state;
    }
};
//# sourceMappingURL=ma-navigation-reducer.js.map